import { render, staticRenderFns } from "./DataChecking.vue?vue&type=template&id=117d940e&scoped=true&"
import script from "./DataChecking.vue?vue&type=script&lang=js&"
export * from "./DataChecking.vue?vue&type=script&lang=js&"
import style0 from "./DataChecking.vue?vue&type=style&index=0&id=117d940e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d940e",
  null
  
)

export default component.exports